/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchCapabilityKey,
  KillswitchCapabilityKey$inboundSchema,
} from "./killswitchcapabilitykey.js";

export type KillswitchCapability = {
  label: string;
  key: KillswitchCapabilityKey;
};

/** @internal */
export const KillswitchCapability$inboundSchema: z.ZodMiniType<
  KillswitchCapability,
  unknown
> = z.object({
  label: z.string(),
  key: KillswitchCapabilityKey$inboundSchema,
});

export function killswitchCapabilityFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchCapability, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchCapability$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchCapability' from JSON`,
  );
}
